module.exports = __webpack_public_path__ + "static/media/01.207cf129.jpg";